import HeroSlider from '../components/HeroSlider';
import StatsBar from '../components/StatsBar';
import AboutSection from '../components/AboutSection';
import BrandsSection from '../components/BrandsSection';
import ServicesSection from '../components/ServicesSection';
import ClientsMarquee from '../components/ClientsMarquee';
import ContactSection from '../components/ContactSection';

export default function HomePage() {
  return (
    <>
      <HeroSlider />
      <StatsBar />
      <AboutSection />
      <BrandsSection />
      <ServicesSection />
      <ClientsMarquee />
      <ContactSection />
    </>
  );
}
